module.exports = __webpack_public_path__ + "img/platform-oculus-rift.1fc86200.png";